import React from 'react';

import { asView } from '../../../_lib/ViewFetcher';
import { SearchResults } from '../../../components/blocks/SearchResults';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useWidgetContext } from '../../../_lib/components/Widget';

// @ts-expect-error SearchResults needs to be typed
export function GenericSearchListDefault(props) {
  const { blockLayout } = useBlockContext();
  const { header } = useWidgetContext();
  // if Block is rendered in its own Widget (header=true) the title is displayed as WidgetTitle and should be hidden.
  // otherwise the title should be rendered (f.e. within ContentWrapper)
  return <SearchResults {...props} blockLayout={blockLayout} titleHidden={header} />;
}

export const GenericSearchListDefaultView = asView(GenericSearchListDefault);
